export default __webpack_public_path__ + "static/media/3.7c40c89b.jpg";